/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'user-request-apporve-popup',
  components: {},
  props: ['requstedUserID'],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    getMembersListAgain(){
      this.$store.dispatch('memberAllUsersListFun')
    },
    ApporveChatRequestConfirmFun(){
      let data = {
        is_approved:true
      }
      this.$store.dispatch('apporvedConnectionRequestFun', {data:{id:this.requstedUserID, data:data}}).then((res) =>{
        toast.success(res.data.msg);
        this.getMembersListAgain()
        this.closedApproveChatRequestFun()
        // this.$store.dispatch('chatBroserNotificationFun')
      }).catch((error) => {
        toast.error(error.data.data.non_field_errors || error.data.msg)

      })
    },
    unApproveChatRequestFun(id){
      let data = {
        is_approved:false
      }
      this.$store.dispatch('apporvedConnectionRequestFun', {data:{id:id, data:data}}).then((res) =>{
        toast.success(res.data.msg);
        this.getMembersListAgain();
      }).catch((err)=>{
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })

    },
    confirmBlockedUser(){
      let data = {
        blocked_user : this.requstedUserID
      }
      this.$store.dispatch('createBlockUserFun', data )
      .then((res) => {
        toast.success(res.data.msg);
        this.closedApproveChatRequestFun()
        this.getMembersListAgain()
      }).catch((err) => {
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })
    },
    closedApproveChatRequestFun(){
      bus.$emit('requestApporvePopupStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    }
  },
  watch:{
  }
}
